import Event from '../../core/Event';
import Estimations from '../../../domain/estimations/Estimations';

export default class EstimationsPlaceSucceed extends Event {
    public static type = 'EstimationsPlaceSucceed';

    constructor(public readonly estimations: Estimations) {
        super(EstimationsPlaceSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsPlaceSucceed.ts